import moment from "moment";
import { useEffect, useState } from "react";
import { LuArrowUpRight } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api/api";
import {
  GeneralPaymentDetails,
  InitiateSchoolFeePayment,
  VerifyPayments,
} from "../../api/student";
import Footer from "../../components/Footer";
import SchoolFeeComponent from "../../components/SchoolFeeComponent";
import useActiveSession from "../../hooks/useActiveSession";
import useDetails from "../../hooks/useDetails";
import usePayments from "../../hooks/usePayments";
import { getCurrentUser } from "../../utils/authService";

const SchoolFees = () => {
  const user = getCurrentUser();
  const [schoolFee, setSchoolFee] = useState();
  const [loading, setLoading] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [paymentLevel, setPaymentLevel] = useState("");
  const [paymentSession, setPaymentSession] = useState("");
  const [availableSessions, setAvailableSessions] = useState([]);
  const [fullName, setFullName] = useState("");
  const [btnText, setBtnText] = useState("Proceed to payment");
  const { payment, schoolFeesPayment } = usePayments();
  const navigate = useNavigate();
  const { data } = useDetails();
  const { session } = useActiveSession();

  const [currentPage, setCurrentPage] = useState(1);
  const paymentsPerPage = 5;

  const getPaymentDetails = async () => {
    if (!paymentType || !paymentLevel || !paymentSession) return;
    try {
      const { data } = await api.post("/payments/generate/payment/", {
        student_id: user.role_id,
        payment_type: paymentType,
        level: paymentLevel,
        session_id: Number(paymentSession),
      });
      console.log("ccccc", data);
      setLoading(false);
      setSchoolFee(data);
    } catch (error) {
      console.log(error, "errrorrr");
      setLoading(false);
      toast.error(
        error.response.data.detail || "Error fetching payment details",
      );
      setSchoolFee(null);
      setPaymentType("");
      setPaymentLevel("");
      setPaymentSession("");
    }
  };

  const paySchoolFee = async () => {
    try {
      setBtnText("Initializing...");
      setLoading(true);
      const { data } = await InitiateSchoolFeePayment({
        student_id: user.role_id,
        payment_type: paymentType,
        payment_level: paymentLevel,
        custom_amount: schoolFee?.amount,
      });
      console.log("payment oh", data);
      // const { status, payment_link, reference } = data;
      // toast.success("Initiating payment");
      // window.location.replace(payment_link);
      toast.success("Mock payment successful");
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.error(error.detail || "Initiating payment failed!");
      setBtnText("Initiating payment failed!");
    }
  };

  const getAvailableSession = async () => {
    try {
      const { data } = await api.get(`/portal/academic-sessions/`);
      setAvailableSessions(data?.results);
    } catch (error) {}
  };

  useEffect(() => {
    getPaymentDetails();
  }, [paymentType, paymentLevel, paymentSession]);

  useEffect(() => {
    getAvailableSession();
  }, []);

  // Safely handle undefined or invalid schoolFeesPayment
  const totalPages = payment?.length
    ? Math.ceil(payment.length / paymentsPerPage)
    : 0;

  // Get the current page's data
  const currentPayments =
    payment?.length > 0
      ? payment
          .sort(
            (a, b) => new Date(b.generated_date) - new Date(a.generated_date),
          )
          .slice(
            (currentPage - 1) * paymentsPerPage,
            currentPage * paymentsPerPage,
          )
      : [];

  // Handle navigation
  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const requeryReceipt = (paymentRef) => {
    paymentRequery(paymentRef);
  };

  const printReceipt = (_data) => {
    navigate("/invoice/school-fee", { state: { ..._data, session: getSession(_data) } });
  };

  const getSession = (data) => {
    let session = availableSessions?.find(({id}) => id === data?.session)
    return session?.name
  }
  const getLevel = (data) => {
    return data?.level || data?.metadata?.original_row?.payment_level || "N/A"
  }


  const paymentRequery = async (ref) => {
    if (!ref) return alert("No Payment Reference Found");
    try {
      setLoading(true);
      const response = await VerifyPayments(ref);
      setLoading(false);
      window.location.reload();
    } catch (error) {
      toast.error("Verification Failed");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      setFullName(`${data?.surname} ${data?.othername}`);
    }
  }, [data]);

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <h1 className="text-2xl font-bold text-brand-darkGray">Payments</h1>
          <p className="text-sm text-gray-400">View all payments</p>
        </div>

        <div className="flex gap-3">
          <button
            className="bg-[#5D71C0] py-2 px-3 flex items-center gap-4 md:gap-9 border border-[#E2D49A80] rounded-xl hover:bg-[#5D71C0]/95 hover:scale-105 transition-all ease-in-out"
            onClick={() => navigate("/payments")}
          >
            <p className="text-sm font-medium text-white">Invoice</p>
            <div className="size-9 bg-[#1E2F733B] rounded-lg flex justify-center items-center cursor-pointer group">
              <LuArrowUpRight className="size-[18px] text-white group-hover:scale-125 transition-all ease-in-out" />
            </div>
          </button>
          <button
            className="bg-[#242D6D] py-2 px-3 flex items-center gap-4 md:gap-9 border border-[#E2D49A80] rounded-xl hover:bg-[#5D71C0]/95 hover:scale-105 transition-all ease-in-out"
            onClick={() => navigate("/payments-otherfees")}
          >
            <p className="text-sm font-medium text-white">Other fees</p>
            <div className="size-9 bg-white rounded-lg flex justify-center items-center cursor-pointer group">
              <LuArrowUpRight className="size-[18px]  text-[#242D6D] group-hover:scale-125 transition-all ease-in-out" />
            </div>
          </button>
        </div>
      </div>

      <div className="mt-6 card-body rounded-xl bg-white space-y-10">
        <h5 className="text-lg font-semibold text-brand-darkGray">
          &#x2022; Student information
        </h5>

        <div className="w-full space-y-5">
          <div className="flex flex-col lg:flex-row gap-5">
            <div className="w-full">
              <label className="text-sm font-medium text-gray-600">
                Full name
              </label>
              <input
                type="text"
                defaultValue={fullName}
                className="form-control text-black font-semibold placeholder:text-sm placeholder:text-black"
                disabled
              />
            </div>
            <div className="w-full">
              <label className="text-sm font-medium text-gray-600">
                Matriculation Number
              </label>
              <input
                type="text"
                defaultValue={data?.matric_number}
                className="form-control text-black font-semibold capitalize"
                disabled
              />
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-5">
            <div className="w-full">
              <label className="text-sm font-medium text-gray-600">
                Department
              </label>
              <input
                type="text"
                defaultValue={data?.department}
                className="form-control text-black font-semibold"
                disabled
              />
            </div>
            <div className="w-full">
              <label className="text-sm font-medium text-gray-600">
                Application Number
              </label>
              <input
                type="text"
                defaultValue={data?.application_no}
                className="form-control text-black font-semibold"
                disabled
              />
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-5">
            <div className="w-full">
              <label className="text-sm font-medium text-gray-600">
                Level of Study
              </label>
              <input
                type="text"
                defaultValue={data?.level}
                className="form-control text-black font-semibold"
                disabled
              />
            </div>
            <div className="w-full">
              <label className="text-sm font-medium text-gray-600">
                Academic Session
              </label>
              <input
                type="text"
                defaultValue={data?.session?.name}
                className="form-control text-black font-semibold"
                disabled
              />
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-5">
            <div className="w-full lg:w-[49.3%]">
              <label className="text-sm font-medium text-gray-600">
                School Programme
              </label>
              <input
                type="text"
                defaultValue={data?.programme?.name}
                className="form-control text-black font-semibold"
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      <div className="p-6 bg-white rounded-xl shadow-md mt-6 card-body space-y-10 overflow-hidden">
        <h2 className="text-lg font-semibold mb-4"> &#x2022; Invoice</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse border-none">
            <thead>
              <tr>
                <th className="p-4 font-semibold">Payment Type</th>
                <th className="p-4 font-semibold">Session</th>
                <th className="p-4 font-semibold">Payment Level</th>
                <th className="p-4 font-semibold">Reference</th>
                <th className="p-4 font-semibold">Instalment</th>
                <th className="p-4 font-semibold">Amount</th>
                <th className="p-4 font-semibold">Date</th>
                <th className="p-4 font-semibold">Status</th>
                <th className="p-4 font-semibold">Action</th>
                {/* <th className="p-4 font-medium">Balance</th> */}
              </tr>
            </thead>
            <tbody>
              {/* Dynamic Rows for Current Page */}
              {currentPayments
                .sort(
                  (a, b) =>
                    new Date(b.generated_date) - new Date(a.generated_date),
                )
                .map((payment) => {
                  let paymentStatus = payment?.metadata?.status ?? payment?.metadata?.original_row?.payment_status?.toLowerCase() ?? "N/A";
                  let installment = payment?.metadata?.original_row?.installment || payment?.payment_type || null;
                  
                  return (
                  <tr key={payment.id} className="hover:bg-gray-50">
                    <td className="p-4 capitalize">
                      {payment.category || "School Fees"}
                    </td>
                    <td className="p-4">{getSession(payment) || payment.metadata?.original_row?.payment_session }</td>
                    <td className="p-4">{getLevel(payment)}</td>
                    <td className="p-4">{payment.metadata.paystack_ref}</td>
                    <td className="p-4 capitalize">
                      {installment || "N/A"}
                    </td>
                    <td className="p-4">
                      ₦{Number(payment.amount_paid).toLocaleString("en-NG")}
                    </td>
                    <td className="p-4">
                      {moment(payment.confirmed_at).format(
                        "dddd, MMMM Do YYYY, h:mm:ss A",
                      )}
                    </td>
                    <td className="p-4">{paymentStatus}</td>
                    <td
                      className={`p-4 font-medium hover:cursor-pointer ${
                        (paymentStatus?.toLowerCase() === "success" || paymentStatus === "paid")
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                      onClick={
                        (paymentStatus?.toLowerCase() === "success" || paymentStatus === "paid")
                          ? () => printReceipt(payment)
                          : () => requeryReceipt(payment.metadata?.paystack_ref)
                      }
                    >
                      {(paymentStatus?.toLowerCase() === "success" || paymentStatus === "paid")
                        ? "Print"
                        : "Requery"}
                    </td>
                  </tr>
                )})}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="flex gap-3 items-center mt-4">
          <button
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded-md ${
              currentPage === 1
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-[#5D71C0] text-white hover:bg-[#5D71C0]/90"
            }`}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 rounded-md ${
              currentPage === totalPages
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-[#5D71C0] text-white hover:bg-[#5D71C0]/90"
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default SchoolFees;
